import styled from 'styled-components';
import Skeleton from '@mui/material/Skeleton'

export const StyledSkeleton = styled(Skeleton)`
  display: block;
  ${({margin}) => margin && `margin: ${margin};`}
`;

export default StyledSkeleton;
